import { findRecipients } from './actions';
import { 
  CLEAR_RECIPIENTS
} from './actions';
import { recipientsMapper } from '../../../../../../../../helpers';

export const reducer = (state = { data: [] }, action) => {
  switch (action.type) {
    case findRecipients.pending.type:
      return {
        ...state,
        isFetching: true,
        hasError: false,
      };
    case findRecipients.fulfilled.type:
      return {
        ...state,
        isFetching: false,
        data: recipientsMapper(action.payload),
      };
    case findRecipients.rejected.type:
      return {
        ...state,
        isFetching: false,
        hasError: true,
      };   
    case CLEAR_RECIPIENTS:
      return {
        ...state,
        data: [],
      };   
    default:
      return state;
  }
};